export default __webpack_public_path__ + "static/media/VehicleDetention.99420c6d.xlsx";